import { queryOptions } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import { appsSearchQueryKeys } from "./key-factory";

export const createAppsDescriptionQuery = () =>
    queryOptions({
        enabled: salesSettingsHelper.isConsolidatedAppsEnabled,
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: appsSearchQueryKeys.description(),
        queryFn({ signal }) {
            return salesApiService.appsSearchFilters.fetchDescription({ cancellation: signal });
        },
    });
